import { ReactNode } from "react";
import { toast } from "../components/toast/toast";

export function copyToClipboard(content: string, toastMsg?: ReactNode) {
    navigator.clipboard &&
        navigator.clipboard
            .writeText(content)
            .then(() => {
                toast.success(toastMsg || "Link Copied");
            })
            .catch((e) => console.log(e));
}
